import type {KeyTextField} from '@prismicio/client'
import dynamic from 'next/dynamic'
import type {IntegrationsContainerSliceDefaultPrimaryCategoriesItem} from 'prismicio-types'
import {forwardRef} from 'react'
import {Icon} from 'src/common/Icon'

const CategoryList = dynamic(() => import('./CategoryList').then((mod) => mod.CategoryList), {
  ssr: false,
})

type DesktopStickySearchBoxV2Props = {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  searchText: string
  categories: IntegrationsContainerSliceDefaultPrimaryCategoriesItem[]
  selectedCategory: number
  changeCategory: (index: number) => void
  searchPlaceholder?: KeyTextField
}

export const SearchBox = forwardRef<HTMLDivElement, DesktopStickySearchBoxV2Props>(
  ({handleChange, searchText, categories, selectedCategory, changeCategory, searchPlaceholder}, ref) => (
    <div className="flex w-full gap-2 max-md:flex-col" ref={ref}>
      <div className="relative flex md:w-[282px]">
        <input
          className="
            text-tg-body-m
            h-9
            w-full
            rounded-[4px]
            border
            border-black/[10%]
            py-2.5
            !pl-11
            !pr-3
            text-black
            placeholder:text-moss-grey-200
            hover:bg-grey-110
            focus:outline
            focus:outline-1
            focus:outline-[#94CC32]
            lg:w-[520px]
            "
          placeholder={searchPlaceholder || ''}
          value={searchText}
          onChange={handleChange}
        />
        <Icon name="search" className="absolute left-4 top-2.5 size-4" />
      </div>
      <CategoryList
        trackingData={{
          mktgId: 'integrations-category',
          dataType: 'integrations-category-button',
          pageName: 'integrations',
        }}
        categories={categories}
        selectedCategory={selectedCategory}
        onClick={changeCategory}
      />
    </div>
  ),
)
